import React, { Component } from "react";
import styled, { css } from "styled-components";
import Text from "./Text";
import { portalColors } from "./BusinessPortalComponents";

export const TextInput = styled.input`
    color: ${p => p.color || portalColors.text};
    font-family: ${p => p.fontFamily || "Manrope, Helvetica, sans-serif"};
    text-align: ${p => p.align || "left"};
    background-color: ${p => p.backgroundColor || portalColors.surface};
    opacity: ${p => p.opacity || "1"};
    width: ${p => p.width || "100%"};
    height: ${p => p.height || "46px"};
    flex-basis: ${p => p.flexBasis};
    padding: ${p => p.padding || "0 1rem"};
    border-radius: ${p => p.borderRadius || "8px"};
    border: ${p => p.border || `1px solid ${portalColors.inputBorder}`};
    border-bottom: ${p => p.borderBottom};
    margin: ${p => p.margin || "0"};
    box-sizing: border-box;
    font-size: ${p => p.size || "0.875rem"};
    overflow: ${p => p.hiddenOverFlow && "hidden"};
    font-weight: ${p => p.fontWeight || "500"};
    max-width: ${p => p.maxWidth};
    box-shadow: ${p => p.boxShadow || portalColors.inputShadow};
    ::placeholder {
        opacity: ${p => p.opacity || "initial"};
        color: ${p => p.placeholderColor || portalColors.textSoft};
        font-weight: ${p => p.placeholderWeight || "400"};
        text-align: ${p => (p.align || p.placeholderAlignment) || "left"};
        font-size: ${p => p.placeholderSize || "0.875rem"};
    };
    ${p => p.isHighlighted && css`
        border: 1px solid red !important;
    `};
    ::-webkit-inner-spin-button { display: none; }
    ::-webkit-datetime-edit-text { 
        color: ${portalColors.text}; 
        padding: 0 0.3rem; 
    }
    ::-webkit-datetime-edit-month-field { color: ${p => p.color || portalColors.text}; } 
    ::-webkit-datetime-edit-day-field { color: ${p => p.color || portalColors.text}; }
    ::-webkit-datetime-edit-year-field { color: ${p => p.color || portalColors.text}; }
    ::-webkit-calendar-picker-indicator { background: ${portalColors.text}; }

    ${p => p.isHideDefaultCalendarIcon && css`
        ::-webkit-calendar-picker-indicator { 
            background: none; 
            height: 25px;
            width: 25px;
        }
    `};

    &:focus {
        outline: none;
        border: 1px solid ${portalColors.inputBorder};
        box-shadow: ${portalColors.inputShadow};
        background-color: ${p => p.backgroundColor || portalColors.surface};
    }

    &:disabled {
        background-color: ${portalColors.surfaceTertiary};
        color: ${portalColors.textSoft};
        cursor: not-allowed;
    }
`;

export const ErrorText = styled(Text)`
    color: red;
    text-align: ${p => (p.align || p.errorTextAlign) || "left"};
    font-size: 12px;
    margin: ${p => p.errorMargin || "0 20px 5px"};
    height: ${p => (p.errorTextHeight) || "12px"};
    white-space: pre-wrap;

    &:empty {
        display: none;
    }
`;

class FormField extends Component {
    render() {
        const { placeholder, errors, onChange, type, onFocus, showErrors, errorTextAlign, isDisabled, ...styleProps } = this.props;
        const errorsArray = errors ? errors : [];
        return (
            <div>
                <TextInput
                    placeholder={placeholder}
                    opacity="1.0"
                    type={type}
                    isHighlighted={errorsArray.length > 0}
                    onChange={onChange}
                    onFocus={onFocus}
                    disabled={isDisabled}
                    {...styleProps}
                />
                {showErrors && <ErrorText errorTextAlign={errorTextAlign} {...styleProps}>{errorsArray}</ErrorText>}
            </div>
        );
    }
}

export default FormField;
